var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTearSheetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4421 6.88586V18.6H1.4V1.4H10.4204L10.5939 1.57852L10.8935 6.23896C10.8997 6.33622 10.9752 6.41481 11.0721 6.42503L15.4421 6.88586ZM16.8421 18.6667V6.552C16.842 6.19862 16.7057 5.85973 16.4629 5.60978L11.3913 0.390222C11.1484 0.140428 10.8191 7.54501e-05 10.4758 0H1.29555C0.951946 0 0.622419 0.140476 0.379457 0.390524C0.136495 0.640573 0 0.979711 0 1.33333V18.6667C0 19.0203 0.136495 19.3594 0.379457 19.6095C0.622419 19.8595 0.951946 20 1.29555 20H15.5466C15.8902 20 16.2197 19.8595 16.4626 19.6095C16.7056 19.3594 16.8421 19.0203 16.8421 18.6667Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 9.57422L13.2533 9.57422",
    stroke: "#767676",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.77563 14.3145L13.2533 14.3145",
    stroke: "#767676",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTearSheetIcon);
export default __webpack_public_path__ + "static/media/TearSheetIcon.f5cde51c77f3f9a111cb670e8b47f02a.svg";
export { ForwardRef as ReactComponent };